(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ls-coming-soon"] && !Shopify.designMode) return;
  try {
    
(() => {
  function mount() {
    document.querySelectorAll('.visual-frame:not([data-ready])').forEach(frame => {
      frame.dataset.ready = 'true';
      const button = frame.closest('figure').querySelector('[data-motion-toggle]');
      const video = frame.querySelector('video');
      const label = button.querySelector('[data-motion-label]');
      const icon = button.querySelector('.motion-icon');
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      const compact = window.matchMedia('(max-width: 720px)');
      const connection = navigator.connection;
      let wantsMotion = !reduced.matches && !connection?.saveData;
      let inView = !('IntersectionObserver' in window);
      let source = '';
      let failed = false;
      let playing = false;
      let attempt = 0;
      let pending = false;
      button.hidden = !(frame.dataset.loopDesktop || frame.dataset.loopMobile);
      const render = active => {
        playing = active;
        // Keep the still poster stationary; only the actual film is motion.
        frame.dataset.motion = 'paused';
        button.setAttribute('aria-pressed', String(active));
        label.textContent = active ? button.dataset.pause : button.dataset.play;
        icon.textContent = active ? 'Ⅱ' : '▷';
      };
      const update = async () => {
        const active = wantsMotion && inView && !document.hidden;
        const next = compact.matches ? (frame.dataset.loopMobile || frame.dataset.loopDesktop) : (frame.dataset.loopDesktop || frame.dataset.loopMobile);
        if (!active || !next || failed) {
          ++attempt; pending = false; video.pause(); render(false);
          if (!next || failed) video.hidden = true;
          return;
        }
        if (source === next && (pending || !video.paused)) return;
        const token = ++attempt;
        if (source !== next) { source = next; video.hidden = true; video.src = next; video.load(); }
        pending = true;
        try {
          await video.play();
          // An older play promise must never pause a newer playback request.
          if (token !== attempt) return;
          pending = false;
          video.hidden = false;
          render(!video.paused);
        } catch { if (token === attempt) { pending = false; render(false); } }
      };
      video.addEventListener('playing', () => { video.hidden = false; render(true); });
      video.addEventListener('pause', () => render(false));
      video.addEventListener('error', () => { failed = true; update(); });
      button.addEventListener('click', () => {
        wantsMotion = !(playing || pending);
        if (wantsMotion && failed) { failed = false; source = ''; }
        frame.dataset.userMotion = String(wantsMotion);
        update();
      });
      document.addEventListener('visibilitychange', update);
      reduced.addEventListener('change', () => { frame.dataset.userMotion = 'false'; wantsMotion = !reduced.matches && !connection?.saveData; update(); });
      compact.addEventListener('change', () => { failed = false; update(); });
      connection?.addEventListener?.('change', () => { if (connection.saveData) { wantsMotion = false; update(); } });
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(entries => { inView = entries[0].intersectionRatio >= .08; update(); }, { threshold: .08 });
        observer.observe(frame);
        document.addEventListener('shopify:section:unload', e => { if (e.target.contains(frame)) { observer.disconnect(); video.pause(); } });
      }
      update();
    });
    document.querySelectorAll('a[href="#email-privacy"]').forEach(link => {
      if (link.dataset.ready) return;
      link.dataset.ready = 'true';
      link.addEventListener('click', () => { const notice = document.getElementById('email-privacy'); if (notice) notice.open = true; });
    });
    const message = document.querySelector('[data-form-result]');
    if (message) message.focus({ preventScroll: false });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount); else mount();
  document.addEventListener('shopify:section:load', mount);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
